import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { CreateAnalyticsTypeOfIncomeExpenseItemDto } from "../../../../dtos/catalogs/AnalyticsTypeOfIncomeExpenseItem/CreateAnalyticsTypeOfIncomeExpenseItemDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import AnalyticsTypeOfIncomeExpenseItemDetailSkeleton from "./AnalyticsTypeOfIncomeExpenseItemDetailSkeleton";
import {DocumentSaveActionType} from "../../../../helpers/DocumentHelper";

interface IProps {
  model: CreateAnalyticsTypeOfIncomeExpenseItemDto | null;
  modelUpdatedEvent: (
    newModel: CreateAnalyticsTypeOfIncomeExpenseItemDto
  ) => void;
}

interface AnalyticsTypeOfIncomeExpenseItemModel {
  name: string;
  description: string;
  createdDate: Date;
  itemType?: number;
}
export const AnalyticsTypeOfIncomeExpenseItemDetail = ({
  model,
  modelUpdatedEvent,
}: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<AnalyticsTypeOfIncomeExpenseItemModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const [tabIndex, setTabIndex] = useState(0);
  const { saveHandler, closeHandler } = modalViewContext;

  useEffect(() => {
    if (model) {
      setValue("name", model.name);
      setValue("description", model.description);
      setValue("createdDate", model.createdDate);
      setValue("itemType", model.itemType);
    }
  }, [model]);

  const handleFormSubmit = async (
    action: DocumentSaveActionType,
    data: AnalyticsTypeOfIncomeExpenseItemModel
  ) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: CreateAnalyticsTypeOfIncomeExpenseItemDto = {
        ...model,
        ...data,
      };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <AnalyticsTypeOfIncomeExpenseItemDetailSkeleton />
      </>
    );
  }
  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <button
          onClick={() => handleTabChange(0)}
          className={`btn  ${tabIndex === 0 ? "custom-btn" : "btn btn-light"}`}
        >
          Main
        </button>

        <CatalogModalViewHeader
          onSave={handleSubmit((data) => handleFormSubmit("save", data))}
          onClose={closeHandler}
        />
        <div className="panel panel-primary tabs-style-2">
          <div className=" tab-menu-heading">
            <div className="tabs-menu1">
              {/* <!-- Tabs --> */}
              <Tabs
                defaultActiveKey="0"
                activeKey={tabIndex}
                className=" panel-tabs main-nav-line "
              >
                <Tab eventKey="0" title={undefined}>
                  <div
                    className={
                      "panel-body tabs-menu-body main-content-body-right"
                    }
                  >
                    <Row>
                      <Col sm={6}>
                        <NFTextInput title={"Name"} fieldName={"name"} />
                      </Col>
                      <Col sm={6}>
                        <NFTextInput
                          title={"Unique code"}
                          fieldName={"uniqueCode"}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6}>
                        <NFDateInput
                          title={"Created Date"}
                          fieldName={"createdDate"}
                        />
                      </Col>
                    </Row>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </FormProvider>
    </>
  );
};
